<template>
	<div class="basic-container popup">
		<div class="popup-visit-company-area">
			<form name="businessPlanForm" id="businessPlanForm" method="post" enctype="multipart/form-data">
				<h4>사업계약서</h4>
				<section class="md-ml-5">
					<div class="block">
						<label class="font-bold">협약기간</label>
						<div class="date-wrapper">
							<Datepicker
								ref="agreementStartDate"
								:calendar-button-icon="'fal fa-calendar'"
								:calendar-button="true"
								:format="'yyyy-MM-dd'"
								:language="ko"
								:div-class="'data'"
								:input-class="'dateTypeInput'"
								v-model="agreementStartDate"
								name="agreementStartDate"
								@input="changeStartDate"
								:disabled="isCompany || (!isCompany && isReadOnly)"
							></Datepicker>
							<span> ~ </span>
							<Datepicker
								ref="agreementEndDate"
								:calendar-button-icon="'fal fa-calendar'"
								:calendar-button="true"
								:format="'yyyy-MM-dd'"
								:language="ko"
								:div-class="'data'"
								:input-class="'dateTypeInput'"
								v-model="agreementEndDate"
								name="agreementEndDate"
								@input="changeEndDate"
								:disabled="isCompany || (!isCompany && isReadOnly)"
							></Datepicker>
						</div>
					</div>
					<div class="block">
						<label class="font-bold web-mt-15" style="vertical-align: top;">계약서</label>
						<file-input-drag
							target-id="AGREEMENT_FILE"
							target-name="AGREEMENT_FILE"
							v-if="!isCompany"
							v-show="agreementFile == null"
							accept="image/png,image/jpg,image/jpeg,image/gif,.pdf,.hwp,*.docx,.zip,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
							:on-change="addFile"
							:multiple="false"
						/>
						<div v-if="agreementFile" class="agreement-img-file">
							<a :href="CONST.API_SERVER + '/okta/file/' + agreementFile.split('|')[0]" download>
								<div class="file-ellipsis">{{ agreementFile.split('|')[1] }}</div>
							</a>
							<img
								v-if="!isCompany && agreementFile.split('|')[0] === ''"
								class="icon-trash trash-box"
								:src="require('../../assets/images/icon/icon-trash@2x.png')"
								@click="delFile('AGREEMENT_FILE')"
							/>
							<input type="hidden" name="agreementFile" v-model="agreementFile" />
						</div>
					</div>
				</section>

				<div class="business-plantitle">
					<h4 class="report">사업계획서</h4>
					<button type="button" class="greenBtn tiny web-hide mr-1" @click="addRow('businessPlanFile')">+추가</button>
				</div>
				<div v-if="businessPlanFileList && businessPlanFileList.length > 0" class="w-20">
					<section v-for="(fileVO, i) in businessPlanFileList" :key="'businessPlanFileList_' + i" class="business-planbox">
						<div class="block half">
							<div v-if="fileVO.planFile" class="plan-img-file">
								<a :href="CONST.API_SERVER + '/okta/file/' + fileVO.planFile.split('|')[0]" download
									><div class="file-ellipsis">{{ fileVO.planFile.split('|')[1] }}</div></a
								>
								<!--								<img-->
								<!--									v-if="fileVO.planState === 'STANDBY'"-->
								<!--									class="icon-trash trash-box"-->
								<!--									:src="require('../../assets/images/icon/icon-trash@2x.png')"-->
								<!--									@click="delFile('BUSINESS_PLAN_FILE' + i)"-->
								<!--								/>-->
							</div>
						</div>
						<div class="block half plan-state-box">
							<div class="col-header" style="width: 70px;">
								<p class="ma-0" style="margin-top: 4px !important;" v-if="fileVO.planState === 'APPROVE'">
									<span class="color-blue">■ </span>승인완료
								</p>
								<p class="ma-0" v-else-if="fileVO.planState === 'NOT_APPROVE'"><span class="color-red">■ </span>미승인</p>
								<p class="ma-0" v-else><span class="color-mushroom">■ </span>승인대기</p>
							</div>
							<div class="text-right">
								<button
									type="button"
									name="delRow"
									class="grayBtn tiny mr-1"
									@click="delRow('businessPlanFile', i)"
									v-if="!isCompany && fileVO.planState !== 'APPROVE'"
								>
									-삭제
								</button>
								<button
									type="button"
									name="addRow"
									class="greenBtn tiny mobile-hide"
									@click="addRow('businessPlanFile')"
									v-if="!isCompany && businessPlanFileList.length === i + 1"
									v-show="!uploadPlanOpen && finalPlanState !== 'STANDBY'"
								>
									+추가
								</button>
							</div>
						</div>
					</section>
				</div>
				<section v-if="uploadPlanOpen" class="business-planfile">
					<div class="block half" v-if="uploadPlanFile">
						<div class="plannew-img-file">
							<div class="file-ellipsis">
								{{ uploadPlanFile.name }}
							</div>
							<img
								v-if="!isCompany && uploadPlanFile != null && businessPlanFileList.length < 1"
								class="icon-trash trash-box"
								:src="require('../../assets/images/icon/icon-trash@2x.png')"
								@click="delFile('TEMP_BUSINESS_PLAN_FILE')"
							/>
						</div>
					</div>
					<div class="block" v-show="uploadPlanFile == null" :class="businessPlanFileList && businessPlanFileList.length > 0 ? 'half' : ''">
						<file-input-drag
							class="w-20"
							:target-id="'TEMP_BUSINESS_PLAN_FILE'"
							:target-name="'TEMP_BUSINESS_PLAN_FILE'"
							accept="image/png,image/jpg,image/jpeg,image/gif,.pdf,.hwp,*.docx,.zip,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
							v-if="!isCompany"
							:on-change="addFile"
							:multiple="false"
						/>
					</div>
					<div class="block half float-right deletebox" v-if="businessPlanFileList && businessPlanFileList.length > 0">
						<div class="mobile-right">
							<button type="button" name="delRow" class="grayBtn tiny" @click="uploadPlanClose">
								-삭제
							</button>
						</div>
					</div>
				</section>

				<h4>협약프로그램</h4>
				<section class="programe-checkbox">
					<div
						v-for="programVO in programCodeList"
						:key="programVO.programCode"
						class="block half"
						:class="[
							{
								'last-div':
									programVO.programCode === 'P10' ||
									programVO.programCode === 'P11' ||
									programVO.programCode === 'P12' ||
									programVO.programCode === 'P13',
							},
							{
								'md-w100':
									programVO.programCode === 'P09' ||
									programVO.programCode === 'P10' ||
									programVO.programCode === 'P11' ||
									programVO.programCode === 'P12' ||
									programVO.programCode === 'P13',
							},
						]"
					>
						<input
							type="checkbox"
							:disabled="isCompany || (!isCompany && isReadOnly)"
							v-model="programVO.stateUse"
							@change="etcCheck(programVO.programCode)"
							:id="programVO.programCode"
						/><label
							:for="programVO.programCode"
							:class="
								programVO.programCode === 'P10' ||
								programVO.programCode === 'P11' ||
								programVO.programCode === 'P12' ||
								programVO.programCode === 'P13'
									? 'last-label'
									: ''
							"
							>{{ programVO.programName }}</label
						><input
							type="text"
							placeholder="기타1 프로그램명을 입력하세요."
							class="last-input"
							:readonly="isCompany"
							v-if="programVO.programCode === 'P10'"
							v-model="etcProgramName1"
						/>
						<input
							type="text"
							placeholder="기타2 프로그램명을 입력하세요."
							class="last-input"
							:readonly="isCompany"
							v-if="programVO.programCode === 'P11'"
							v-model="etcProgramName2"
						/>
						<input
							type="text"
							placeholder="기타3 프로그램명을 입력하세요."
							class="last-input"
							:readonly="isCompany"
							v-if="programVO.programCode === 'P12'"
							v-model="etcProgramName3"
						/>
						<input
							type="text"
							placeholder="기타4 프로그램명을 입력하세요."
							class="last-input"
							:readonly="isCompany"
							v-if="programVO.programCode === 'P13'"
							v-model="etcProgramName4"
						/>
					</div>
				</section>
			</form>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import eventBus from '@/plugins/event-bus';
import FileInputDrag from '@/components/common/FileInputDrag';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';
import moment from 'moment-timezone';

export default {
	title: '사업계획서',
	name: 'PopupVisit',
	props: ['modalParam'],
	components: { FileInputDrag, Datepicker: Datepicker },
	data: function() {
		return {
			ko: ko,
			CONST,
			loginMember: null,
			matchData: null,
			uploadPlanOpen: false,
			useEtc: true,
			startDate: '',
			endDate: '',
			agreementStartDate: '',
			agreementEndDate: '',
			agreementFile: null,
			uploadPlanFile: null,
			businessPlanFileList: [],
			programCodeList: null,
			etcProgramName1: '',
			etcProgramName2: '',
			etcProgramName3: '',
			etcProgramName4: '',
			planState: false,
			agreementState: 'NONE',
			finalPlanState: 'NONE',
		};
	},
	watch: {},
	created() {},
	computed: {
		isCompany() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
		isReadOnly() {
			return this.agreementState !== 'NONE';
		},
	},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		let matchData = this.$device.loadLocalData('MATCH_DATA');
		if (matchData) this.matchData = JSON.parse(matchData);

		this.agreementState = this.matchData.agreementState;
		this.finalPlanState = this.matchData.finalPlanState;
		this.startDate = Number(this.$moment(this.matchData.startDate).format('YYYYMMDD'));
		this.endDate = Number(this.$moment(this.matchData.endDate).format('YYYYMMDD'));
		if (this.matchData.agreementStartDate)
			this.agreementStartDate = this.$moment(moment(this.matchData.agreementStartDate).tz('Asia/Seoul')).format('YYYY-MM-DD');
		if (this.matchData.agreementEndDate)
			this.agreementEndDate = this.$moment(moment(this.matchData.agreementEndDate).tz('Asia/Seoul')).format('YYYY-MM-DD');
		if (this.matchData.agreementFile) this.agreementFile = this.matchData.agreementFile;
		if (this.matchData.planFileList && this.matchData.planFileList.length > 0) {
			this.businessPlanFileList = this.matchData.planFileList;
			for (let i = 0; i < this.businessPlanFileList.length; i++) {
				if (this.businessPlanFileList[i].planState !== 'NOT_APPROVE') {
					this.planState = true;
				}
			}
		} else {
			this.uploadPlanOpen = true;
		}
		this.getProgramCodeList();
		eventBus.$on(
			CONST.EVENTS.SAVE_MODAL,
			function(v, t) {
				if (v === 'modalPlan') {
					if (t === 'SAVE') {
						this.doSubmit(t);
						return false;
					}
				}
			}.bind(this),
		);
	},
	beforeDestroy() {
		eventBus.$off(CONST.EVENTS.SAVE_MODAL);
	},
	methods: {
		changeStartDate: function() {
			if (this.agreementStartDate !== '') {
				let agreementStartDate = this.$moment(this.agreementStartDate).format('YYYYMMDD');
				let agreementEndDate = this.$moment(this.agreementEndDate).format('YYYYMMDD');

				if (this.startDate > Number(agreementStartDate)) {
					alert('협약시작일은 사업시작일보다 이전일 수 없습니다.');
					this.agreementStartDate = '';
					this.$refs['agreementStartDate'].clearDate();
					this.$refs['agreementStartDate'].$el.focus();
				}
				if (this.endDate < Number(agreementStartDate)) {
					alert('협약시작일은 사업종료일보다 이후일 수 없습니다.');
					this.agreementStartDate = '';
					this.$refs['agreementStartDate'].clearDate();
					this.$refs['agreementStartDate'].$el.focus();
				} else if (agreementEndDate !== '' && Number(agreementStartDate) > Number(agreementEndDate)) {
					alert('협약마감일보다 이후일 수 없습니다.');
					this.agreementStartDate = '';
					this.$refs['agreementStartDate'].clearDate();
					this.$refs['agreementStartDate'].$el.focus();
				}
			}
		},
		changeEndDate: function() {
			if (this.agreementEndDate !== '') {
				let agreementStartDate = this.$moment(this.agreementStartDate).format('YYYYMMDD');
				let agreementEndDate = this.$moment(this.agreementEndDate).format('YYYYMMDD');

				if (this.startDate > Number(agreementEndDate)) {
					alert('협약종일은 사업시작일보다 이전일 수 없습니다.');
					this.agreementEndDate = '';
					this.$refs['agreementEndDate'].clearDate();
					this.$refs['agreementEndDate'].$el.focus();
				}
				if (this.endDate < Number(agreementEndDate)) {
					alert('협약종료일은 사업종료일보다 이후일 수 없습니다.');
					this.agreementEndDate = '';
					this.$refs['agreementEndDate'].clearDate();
					this.$refs['agreementEndDate'].$el.focus();
				} else if (agreementStartDate !== '' && Number(agreementStartDate) >= Number(agreementEndDate)) {
					alert('협약시작일보다 이전일 수 없습니다.');
					this.agreementEndDate = '';
					this.$refs['agreementEndDate'].clearDate();
					this.$refs['agreementEndDate'].$el.focus();
				}
			}
		},
		getProgramCodeList: function() {
			let formData = new FormData();
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/common/getProgramCodeList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.programCodeList = res.data.data;
						for (let i = 0; i < this.programCodeList.length; i++) {
							this.programCodeList[i].stateUse = false;
							this.programCodeList[i].seqNo = 0;
						}
						//이미 체결된 협약프로그램 매칭
						if (this.matchData != null) {
							let userProgramList = this.matchData.programList;
							if (userProgramList != null && userProgramList.length > 0) {
								for (let i = 0; i < this.programCodeList.length; i++) {
									for (let j = 0; j < userProgramList.length; j++) {
										if (this.programCodeList[i].programCode === userProgramList[j].programCode) {
											if (userProgramList[j].stateUse === 'Y') {
												this.programCodeList[i].stateUse = true;
												this.programCodeList[i].seqNo = userProgramList[j].seqNo;
											}
										}
										if (userProgramList[j].programCode === 'P10' && userProgramList[j].etcProgramNm != '') {
											this.etcProgramName1 = userProgramList[j].etcProgramNm;
											this.useEtc = false;
										} else if (userProgramList[j].programCode === 'P11' && userProgramList[j].etcProgramNm != '') {
											this.etcProgramName2 = userProgramList[j].etcProgramNm;
											this.useEtc = false;
										} else if (userProgramList[j].programCode === 'P12' && userProgramList[j].etcProgramNm != '') {
											this.etcProgramName3 = userProgramList[j].etcProgramNm;
											this.useEtc = false;
										} else if (userProgramList[j].programCode === 'P13' && userProgramList[j].etcProgramNm != '') {
											this.etcProgramName4 = userProgramList[j].etcProgramNm;
											this.useEtc = false;
										}
									}
								}
							}
						}
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		addFile: function(e) {
			let fileInputName = e.target ? e.target.name : e.name;
			let fileInputList = e.target ? e.target.files : e.files;
			// let idx = e.id.charAt(e.id.length - 1);
			if (fileInputName === 'TEMP_BUSINESS_PLAN_FILE') {
				try {
					let file = fileInputList[0];
					if (file) this.uploadPlanFile = file;
					// if (file) this.businessPlanFileList[idx].planFile = '|' + file.name;
				} catch (e) {
					console.error(e);
				}
			}
			if (fileInputName === 'AGREEMENT_FILE') {
				try {
					let file = fileInputList[0];
					if (file) this.agreementFile = '|' + file.name;
				} catch (e) {
					console.error(e);
				}
			}
		},
		uploadPlanClose: function() {
			if (this.uploadPlanFile == null) this.uploadPlanOpen = !this.uploadPlanOpen;
			this.uploadPlanFile = null;
			let file = 'TEMP_BUSINESS_PLAN_FILE';
			let fileInput = document.getElementById(file);
			fileInput.value = null;
		},
		addRow: function(rowsId) {
			if (rowsId === 'businessPlanFile') {
				this.uploadPlanOpen = true;
				// this.businessPlanFileList.push({
				// 	planFile: null,
				// 	planState: 'STANDBY',
				// });
			}
		},
		delRow: function(rowsId, idx) {
			if (rowsId === 'businessPlanFile') {
				if (this.businessPlanFileList.length === 1 && this.businessPlanFileList[0].planState === 'APPROVE') {
					window.alert('마지막 행 입니다. ');
					return;
				}
				this.businessPlanFileList.splice(idx, 1);
				if (this.businessPlanFileList.length > 0) {
					let count = 0;
					for (let i = 0; i < this.businessPlanFileList.length; i++) {
						if (this.businessPlanFileList[i].planState === 'STANDBY') {
							count++;
						}
						if (i + 1 === this.businessPlanFileList.length) {
							this.finalPlanState = this.businessPlanFileList[i].planState;
						}
					}
					if (count === 0) {
						this.uploadPlanOpen = false;
					}
				} else {
					this.uploadPlanOpen = true;
				}
			}
		},
		delFile: function(file) {
			if (file === 'AGREEMENT_FILE') {
				this.agreementFile = null;
				let fileInput = document.getElementById(file);
				fileInput.value = null;
			}
			if (file === 'TEMP_BUSINESS_PLAN_FILE') {
				this.uploadPlanFile = null;
				let fileInput = document.getElementById(file);
				fileInput.value = null;
			}
			if (file.indexOf('BUSINESS_PLAN_FILE') > -1 && this.businessPlanFileList.length > 0) {
				let idx = file.charAt(file.length - 1);
				this.businessPlanFileList[idx].planFile = null;
				let fileInput = document.getElementById(file);
				fileInput.value = null;
			}
		},
		etcCheck: function(programCode) {
			if (programCode === 'P10') this.useEtc = !this.useEtc;
			else if (programCode === 'P11') this.useEtc = !this.useEtc;
			else if (programCode === 'P12') this.useEtc = !this.useEtc;
			else if (programCode === 'P13') this.useEtc = !this.useEtc;
		},
		doSubmit: function() {
			if (this.agreementStartDate !== '' && this.agreementEndDate !== null) {
				let agreementStartDate = Number(this.$moment(this.agreementStartDate).format('YYYYMMDD'));
				let agreementEndDate = Number(this.$moment(this.agreementEndDate).format('YYYYMMDD'));

				if (this.startDate > Number(agreementStartDate)) {
					alert('협약시작일은 사업시작일보다 이전일 수 없습니다.');
					this.agreementStartDate = '';
					this.$refs['agreementStartDate'][0].clearDate();
					this.$refs['agreementStartDate'][0].$el.focus();
					return false;
				} else if (this.endDate < Number(agreementEndDate)) {
					alert('협약시작일은 사업종료일보다 이후일 수 없습니다.');
					this.agreementStartDate = '';
					this.$refs['agreementStartDate'][0].clearDate();
					this.$refs['agreementStartDate'][0].$el.focus();
					return false;
				} else if (agreementEndDate !== '' && Number(agreementStartDate) > Number(agreementEndDate)) {
					alert('협약시작일은 협약마감일보다 이후일 수 없습니다.');
					this.agreementStartDate = '';
					this.agreementStartDate = '';
					this.$refs['agreementStartDate'][0].clearDate();
					this.$refs['agreementStartDate'][0].$el.focus();
					return false;
				}
			} else {
				alert('협약시작일을 선택해 주세요.');
				return false;
			}
			if (this.agreementEndDate !== '' && this.agreementEndDate !== null) {
				let agreementEndDate = Number(this.$moment(this.agreementEndDate).format('YYYYMMDD'));
				let agreementStartDate = Number(this.$moment(this.agreementStartDate).format('YYYYMMDD'));

				if (this.startDate > Number(agreementEndDate)) {
					alert('협약종료일은 사업시작일보다 이전일 수 없습니다.');
					this.agreementEndDate = '';
					this.$refs['agreementEndDate'][0].clearDate();
					this.$refs['agreementEndDate'][0].$el.focus();
					return false;
				} else if (this.endDate < Number(agreementEndDate)) {
					alert('협약종료일은 사업종료일보다 이후일 수 없습니다.');
					this.agreementEndDate = '';
					this.$refs['agreementEndDate'][0].clearDate();
					this.$refs['agreementEndDate'][0].$el.focus();
					return false;
				} else if (agreementStartDate !== '' && Number(agreementStartDate) >= Number(agreementEndDate)) {
					alert('협약종료일은 사업시작일보다 이전일 수 없습니다.');
					this.agreementEndDate = '';
					this.$refs['agreementEndDate'][0].clearDate();
					this.$refs['agreementEndDate'][0].$el.focus();
					return false;
				}
			} else {
				alert('협약마감일을 선택해 주세요.');
				return false;
			}

			if (this.agreementFile === null) {
				alert('사업계약서 파일을 업로드해 주세요.');
				return false;
			}

			if (this.agreementState === 'NONE' && this.uploadPlanFile === null) {
				alert('사업계획서 파일을 업로드해 주세요.');
				return false;
			}
			if (this.agreementState !== 'NONE' && this.businessPlanFileList.length < 1 && this.uploadPlanFile === null) {
				alert('사업계획서 파일을 업로드해 주세요.');
				return false;
			}
			// let fileCount = 0;
			// for (let i = 0; i < this.businessPlanFileList.length; i++) {
			// 	if (this.businessPlanFileList[i].planFile === null) {
			// 		fileCount++;
			// 	}
			// }
			// if (fileCount > 0) {
			// 	alert('사업계획서 파일을 업로드해 주세요.');
			// 	return false;
			// }

			let stateUseCount = 0;
			let notEtcProgramName = true;
			for (let i = 0; i < this.programCodeList.length; i++) {
				if (this.programCodeList[i].stateUse === false) {
					stateUseCount++;
				}
				if (this.programCodeList[i].programCode === 'P10') {
					if (this.programCodeList[i].stateUse === true && this.etcProgramName1 === '') {
						notEtcProgramName = false;
						console.log(notEtcProgramName);
					}
				}
			}
			if (stateUseCount === 13) {
				alert('협약프로그램을 선택해 주세요.');
				return false;
			}
			// if (!notEtcProgramName) {
			// 	alert('기타 협약프로그램명을 작성해 주세요.');
			// 	return false;
			// }

			let form = document.getElementById('businessPlanForm');
			let formData = new FormData(form);
			formData.append('matchSeqNo', this.matchData.matchSeqNo);
			formData.append('userProgramList', JSON.stringify(this.programCodeList));
			if (this.businessPlanFileList && this.businessPlanFileList.length > 0)
				formData.append('userBusinessPlanFileList', JSON.stringify(this.businessPlanFileList));
			if (this.uploadPlanFile != null) formData.append('BUSINESS_PLAN_FILE', this.uploadPlanFile);
			formData.append('etcProgramName1', this.etcProgramName1);
			formData.append('etcProgramName2', this.etcProgramName2);
			formData.append('etcProgramName3', this.etcProgramName3);
			formData.append('etcProgramName4', this.etcProgramName4);
			formData.append('agreementState', 'DONE');
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/businessPlanSubmit.do', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(res => {
					if (res.data.resultCode === 0) {
						alert('저장되었습니다.');
						// this.getVisitData();
						eventBus.$emit('LOAD_POPUP_VISIT_DATA');
						//window.location.reload();
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
	},
};
</script>

<style scoped></style>
